const DashedArrow = (props) => (
  <svg
    width={22}
    height={14}
    viewBox='0 0 22 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.46462 8.3993L7.87463 11.6109C8.41913 12.1569 8.41913 13.0431 7.87463 13.5905C7.3315 14.1365 6.44875 14.1365 5.90562 13.5905L0.611874 8.4847C0.215874 8.0885 0 7.5635 0 6.9993C0 6.4393 0.217251 5.9101 0.6105 5.5153L5.90425 0.4095C6.44875 -0.1365 7.3315 -0.1365 7.876 0.4095C8.41912 0.9555 8.41912 1.8417 7.876 2.3891L4.466 5.5993H20.625C21.3854 5.5993 22 6.2237 22 6.9993C22 7.7693 21.384 8.3993 20.625 8.3993H4.46462Z'
      fill='currentColor'
    />
  </svg>
);
export default DashedArrow;
